import React, { useEffect, useState } from "react";
import { Card, Table, Calendar, Tabs } from "antd";
import { useSearchParams } from "react-router-dom";
import MyMonthTab, { CalendarHeader } from "./MyMonthTab";
import moment from "moment";
import useRequest from "../../hooks/useRequest";
import apiPath from "../../constants/apiPath";
import PageTransition from "../../components/ui/PageTransition";
import PageHeader from "../../components/ui/PageHeader";
import StatusTag from "../../components/ui/StatusTag";
import EmptyState from "../../components/ui/EmptyState";
import ViewToggle from "../../components/ui/ViewToggle";

const Attendance = () => {
  const { request } = useRequest();
  const [sessions, setSessions] = useState([]);
  const [view, setView] = useState("list");
  const [params, setParams] = useSearchParams();
  const tab = params.get("tab") === "history" ? "history" : "month";

  useEffect(() => {
    request({
      url: apiPath.attendanceHistory,
      method: "GET",
      onSuccess: (res) => setSessions(res?.data?.data || []),
    });
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const columns = [
    { title: "Date", dataIndex: "date" },
    { title: "Status", dataIndex: "status", render: (s) => <StatusTag status={s} /> },
    { title: "Shift Start", dataIndex: "loginAt", render: (v) => (v ? moment(v).format("HH:mm") : "-") },
    { title: "Shift End", dataIndex: "logoutAt", render: (v) => (v ? moment(v).format("HH:mm") : "-") },
  ];

  const attendanceDateCellRender = (value) => {
    const dateStr = value.format("YYYY-MM-DD");
    const record = sessions.find((s) => s.date === dateStr);
    if (!record) return null;
    return (
      <div className="i-ems-calendar-cell-content">
        <StatusTag status={record.status} />
        {(record.loginAt || record.logoutAt) && (
          <span style={{ fontSize: 11, color: "var(--i-ems-text-secondary)" }}>
            {record.loginAt ? moment(record.loginAt).format("HH:mm") : "-"}
            {" – "}
            {record.logoutAt ? moment(record.logoutAt).format("HH:mm") : "-"}
          </span>
        )}
      </div>
    );
  };

  const history = (
    <>
      <div style={{ display: "flex", justifyContent: "flex-end", marginBottom: 12 }}>
        <ViewToggle value={view} onChange={setView} />
      </div>
      {view === "list" ? (
        <Card>
          <Table
            rowKey="_id"
            columns={columns}
            dataSource={sessions}
            pagination={{ pageSize: 15 }}
            locale={{ emptyText: <EmptyState message="No attendance records yet" /> }}
          />
        </Card>
      ) : (
        <Card>
          <div className="i-ems-apply-calendar">
            <Calendar dateCellRender={attendanceDateCellRender} headerRender={({ value: v, onChange }) => <CalendarHeader value={v} onChange={onChange} />} />
          </div>
        </Card>
      )}
    </>
  );

  return (
    <PageTransition>
      <PageHeader title="My Attendance" subtitle="Your month at a glance, with your leave balance, and your shift history" />
      <Tabs
        activeKey={tab}
        onChange={(k) => setParams({ tab: k }, { replace: true })}
        destroyInactiveTabPane
        items={[
          { key: "month", label: "My month", children: <MyMonthTab /> },
          { key: "history", label: "Shift history", children: history },
        ]}
      />
    </PageTransition>
  );
};

export default Attendance;
